import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { createHttpParams } from '~/infrastructure/http/params';
import { augmentPaging } from '~/infrastructure/paging';
import { ApiServiceBase, API_NAMES } from '~/services/api';


export interface StockTransactionDateEditingDto {
  transactionDateEditing: boolean;
}

@Injectable({ providedIn: 'root' })
export class TransactionDateEditingService extends ApiServiceBase {
  constructor(injector: Injector, private http: HttpClient) {
    super(injector);
    this.setBase(API_NAMES.adminStock);
  }

  updateTransactionDateEditing(model: any) {
    return this.client.put(this._url("update"), model);
  }

  getTransactionDateEditing(endpoint?: string) {
    return this.http.get<StockTransactionDateEditingDto>(this._url(endpoint));
  }

  private _url(v?: string | undefined) {
    v = v || '';
    return this.url(`/SysConfigTransactions/${v}`);
  }
}
